const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  UPDATE_USER:'UPDATE_USER',
  UPDATE_ROLE:'UPDATE_ROLE',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  CHECK_ROLE: 'CHECK_ROLE',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  updateUser: () => ({ type: actions.UPDATE_USER }),
  updateRole: ()=> ({type: actions.UPDATE_ROLE}),
  login: () => ({
    type: actions.LOGIN_REQUEST,
  }),
  checkRole: (role) => ({
    type: actions.CHECK_ROLE,
    role,
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
